
export default function menuLayout () {
	return {
		restrict: 'E',
		scope: {
			title: '@',
			hasProductRating: '@'
		},
		bindToController: true,
		template: require('./menu-layout.html'),
		transclude: true,
		controller: 'MenuLayoutController',
		controllerAs: 'menuLayout'
	}
};

menuLayout.$inject = [];



// WEBPACK FOOTER //
// ./src/directive/menu-layout/menu-layout.js